import React from 'react';

const MinusIcon = ({size, thick}) => {
    const viewBox = "0 0 " + size + " " + thick;
    const transform = "rotate(90 " + size + " 0)";
    return (
        <svg
        width={size}
        height={thick}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
            <rect x={size} width={size} height={size} transform={transform} fill="#1A1A1A" />
        </svg>
    );
}
    

export default MinusIcon;




// WEBPACK FOOTER //
// ./src/components/Icons/MinusIcon.js